export const apiUrl = "";
